<template>
  <div>
    <QuotationHeader :img_header="header_image" header="สร้างใบเสนอราคา" link_back="stock/quotation/quotationmain"/>
    <Quotation_create/>
  </div>
</template>

<script>
import QuotationHeader from "@/components/admin/stock/quotation/header_quotation/QuotationHeader";
import HeaderImage from "@/assets/quotation.png";
import Quotation_create from "@/components/admin/stock/quotation/Quotation_create";
export default {
  name: "QuotationCreate",
  components: {
    Quotation_create,
    QuotationHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
